export enum TaskPermisson {
    CREATE = "task: create",
    DELETE = "task: delete",
    UPDATE = "task: update",
    VIEW_PAGINATED = "task: view paginated",
    VIEW = "task: view",
    VIEW_ALL_TASK_TYPES = "task: view all task types",
    VIEW_ALL_TASK_TYPE_CUSTOM_FIELD_OPTIONS = "task: view all task type custom field options"
}
